export const mainText = `I've always been obsessed with tech. Growing up,
that went into Lego robotics. My first Raspberry Pi came in
fifth grade, and coding stuck. By the time I started high school I'd written my
first game in Python and finished 'Programming for Dummies.'
What interests me now is where software meets hardware, along
with scalability and reliability. I'd describe my approach as
human-centered design: minimizing cognitive load and maximizing
what people can get out of their machines. I'm a big fan of
Shaw and Nave's Tri-System Theory of Cognition, and excited to
see where the future leads our neural specialization.`;

export const sideText = `Outside of work I enjoy planning, EDM, fashion, and literature (both for research and leisure). `;
